import { render, staticRenderFns } from "./StoreCoupons.vue?vue&type=template&id=20cb63a1"
import script from "./StoreCoupons.vue?vue&type=script&lang=js"
export * from "./StoreCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports